import _map from 'lodash/fp/map';
import _flatMap from 'lodash/fp/flatMap';
import _some from 'lodash/fp/some';
import _pipe from 'lodash/fp/pipe';
import _keys from 'lodash/keys';
import _cloneDeep from 'lodash/cloneDeep';
import _get from 'lodash/get';
import _values from 'lodash/values';
import adjustmentsForDocumentUpdated from '../actions/adjustmentsForDocumentUpdated';
import adjustmentsWithTogglesForDocumentUpdated from '../actions/adjustmentsWithTogglesForDocumentUpdated';
import adjustmentToggled from '../actions/adjustmentToggled';
import viewingToggledUpdated from '../actions/viewingToggledUpdated';
import { getAdjustmentTypesByCode } from '../selectors/adjustmentSelectors';
import { getAdjustmentTogglesByDocument } from '../selectors/adjustmentTogglesSelectors';
import { ACTIVE_KEY } from '../utilities/constants';

const isInvalidPayloadForAdjustmentsForDocumentUpdated = (payload) =>
  payload === undefined ||
  payload.documentCode === undefined ||
  payload.adjustments === undefined;

const isInvalidPayloadForAdjustmentToggled = (payload) =>
  payload === undefined || payload.documentCode === undefined;

const updateAdjustmentsWithToggleState = (adjustments, toggles) => {
  const updatedAdjustments = _cloneDeep(adjustments);

  _keys(adjustments).forEach((adjType) => {
    _keys(adjustments[adjType]).forEach((adjName) => {
      const isActive = _get(toggles, [adjType, adjName, ACTIVE_KEY], true);
      updatedAdjustments[adjType][adjName][ACTIVE_KEY] = isActive;
    });
  });

  return updatedAdjustments;
};

const handleAdjustmentsForDocumentUpdated = (store, action) => {
  if (isInvalidPayloadForAdjustmentsForDocumentUpdated(action.payload)) {
    return;
  }

  const { documentCode, adjustments } = action.payload;

  const adjustmentToggles = getAdjustmentTogglesByDocument(store.getState());

  const adjustmentTogglesForDocument = _get(
    adjustmentToggles,
    documentCode,
    {}
  );

  const adjustmentsWithToggleState = updateAdjustmentsWithToggleState(
    adjustments,
    adjustmentTogglesForDocument
  );

  store.dispatch(
    adjustmentsWithTogglesForDocumentUpdated(
      documentCode,
      adjustmentsWithToggleState
    )
  );
};

const hasInactiveToggles = (adjustmentToggles) =>
  _pipe(
    _values,
    _flatMap(_values),
    _flatMap(_values),
    _map((t) => t.active),
    _some((isActive) => !isActive)
  )(adjustmentToggles);

const handleAdjustmentToggled = (store, action) => {
  if (isInvalidPayloadForAdjustmentToggled(action.payload)) {
    return;
  }

  const { documentCode } = action.payload;

  const adjustments = getAdjustmentTypesByCode(store.getState());
  const adjustmentsForDocument = _get(adjustments, documentCode, {});

  const adjustmentToggles = getAdjustmentTogglesByDocument(store.getState());
  const adjustmentTogglesForDocument = _get(
    adjustmentToggles,
    documentCode,
    {}
  );

  const adjustmentsWithToggleState = updateAdjustmentsWithToggleState(
    adjustmentsForDocument,
    adjustmentTogglesForDocument
  );

  store.dispatch(
    adjustmentsWithTogglesForDocumentUpdated(
      documentCode,
      adjustmentsWithToggleState
    )
  );

  const hasInactive = hasInactiveToggles(adjustmentToggles);

  store.dispatch(viewingToggledUpdated(hasInactive));
};

const toggleMiddleware = (store) => (next) => (action) => {
  next(action);

  switch (action.type) {
    case adjustmentsForDocumentUpdated.type:
      handleAdjustmentsForDocumentUpdated(store, action);
      break;

    case adjustmentToggled.type:
      handleAdjustmentToggled(store, action);
      break;

    default:
  }
};

export default toggleMiddleware;
